import axios from 'axios'
import queryString from 'query-string'
import { store } from 'src/client'
import { CreditCardStatus } from 'src/models/creditCard.models'
import { CreditCardPermissions } from 'src/models/creditCardPermissions.models'
import { CreditCardsResponse } from 'src/queries/creditCard.queries'
import { CreditCardVariant } from 'src/queries/queries.constants'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'
import { GetCreditCardsRequest } from 'src/requests/getCreditCards.request'

// Base params shared by all variants
const baseParams: Partial<GetCreditCardsRequest> = {
  status: CreditCardStatus.Active,
  withPermission: CreditCardPermissions.IssueVirtualCards,
  sortField: 'type',
  sortDirection: 'ASC',
  count: 10,
}

// Variant-specific filters matching the existing Redux thunks exactly
const variantFilters: Record<
  CreditCardVariant,
  Partial<GetCreditCardsRequest>
> = {
  standard: { balanceLockedEnabled: false },
  recurring: { recurrenceEnabled: true },
  guestAccess: { directEnabled: true },
  balanceLock: { balanceLockedEnabled: true },
  issuerCycle: { issuerCycleEnabled: true },
}

export const fetchCreditCardsForForm = async (
  variant: CreditCardVariant,
  page: number = 0,
  keyword?: string,
  billPayEnabled?: boolean,
): Promise<CreditCardsResponse> => {
  const state = store.getState()
  const requestConfig = selectAuthedJsonApiRequestConfig(state)

  const params: GetCreditCardsRequest = {
    ...baseParams,
    ...variantFilters[variant],
    page,
    ...(keyword ? { search: keyword } : {}),
    ...(billPayEnabled ? { billPayEnabled: true } : {}),
  }

  const response = await axios.get<CreditCardsResponse>(
    `creditcards?${queryString.stringify(params)}`,
    requestConfig,
  )
  return response.data
}
